import { siteConfig } from "@/data/siteConfig";
import { Reveal } from "./shared";

export const MarqueeSection = () => {
  const items = [...siteConfig.marquee, ...siteConfig.marquee, ...siteConfig.marquee, ...siteConfig.marquee];
  return (
    <section data-testid="marquee-section" className="bg-navy py-10 overflow-hidden border-y border-white/10">
      <div className="marquee-track">
        {items.map((word, i) => (
          <span key={i} className="mx-8 inline-flex items-center gap-8 font-display text-4xl italic text-cream/25 md:text-5xl">
            {word}
            <span className="text-gold/60 not-italic text-2xl">✦</span>
          </span>
        ))}
      </div>
    </section>
  );
};

export const MissionSection = () => {
  const { mission } = siteConfig;
  return (
    <section id="mission" data-testid="mission-section" className="bg-cream py-24 lg:py-36">
      <div className="mx-auto max-w-[1400px] px-6 lg:px-12">
        <div className="grid gap-16 lg:grid-cols-12">
          <div className="lg:col-span-5">
            <Reveal>
              <p className="text-xs uppercase tracking-[0.3em] text-gold mb-6">{mission.eyebrow}</p>
              <h2 className="font-display text-4xl font-semibold leading-[1.08] tracking-tight text-navy sm:text-5xl lg:text-[3.4rem]">
                {mission.statement}
              </h2>
            </Reveal>
          </div>
          <div className="lg:col-span-6 lg:col-start-7 flex flex-col divide-y divide-navy/10">
            {mission.chapters.map((c, i) => (
              <Reveal key={c.n} delay={i * 0.08} className="py-8 first:pt-0 last:pb-0">
                <div className="flex gap-8">
                  <span className="font-display text-2xl text-gold shrink-0">{c.n}</span>
                  <div>
                    <h3 className="font-display text-2xl text-navy mb-3">{c.title}</h3>
                    <p className="text-base leading-relaxed text-charcoal/80 md:text-lg">{c.body}</p>
                  </div>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
